<template>
<div>
<navigation></navigation>
<!--Main contents-->
  <div class="box_center" id="page_x">
    <h2 class="shadow" style="float: left">Picks</h2>
    <ul class="articles">
      <li style="padding-top:0">
        <adsense v-if="!user || !user.premium"
          ad-client="ca-pub-8213113866781504"
          ad-slot="7783278999"
          ad-layout-key="-8i+1w-dq+e9+ft"
          ad-format="fluid">
        </adsense>
      <div class="article" v-for="pick in picks">
        <a href="#" class="title_article">{{pick.title}}</a>
        <p class="text_article" v-html="pick.content"></p>
        <div class="text_article_pick">
          <b class="article_pick">{{pick.pick}}</b>
          &nbsp; &nbsp;
          <b class="article_pick">{{pick.side}}</b>
          &nbsp; &nbsp;
          <b class="article_pick">{{pick.price}}</b>
          &nbsp; &nbsp;
          <b class="article_pick">{{pick.units}}</b>
          &nbsp;
           <b class="article_pick">{{pick.units == 1 ? 'unit' : 'units'}}</b>
        </div>
      </div>
        <p v-if="picks && picks.length === 0">There are no picks currently posted. To receive picks immediately when they are posted, please set up pick notifications in the <router-link :to="{path: '/myaccount'}">my account section (premium members only).</router-link></p>
        <div class="separator"></div>
      </li>
    </ul>
    <h2 class="shadow" v-if="user && !user.premium" style="height:20px;">Buy Premium Picks</h2>
    <ul class="articles" v-if="user && !user.premium">
      <li style="padding-top:0;">
        <div class="article" v-if="allYear">
          <a href="javascript:;" class="title_article">1 Year All Sports Package</a>
          <p class="text_article">
            Every single expert pick for 365 days! Only <strike v-if="allYear.current_price !== allYear.previous_price">${{allYear.previous_price}}</strike> ${{allYear.current_price}}. Best Value!
            <br />
            <purchase-button :package="allYear" :color="'gold'"></purchase-button>
            <!-- <paypal-button :package="allYear" :size="'medium'" :color="'gold'"></paypal-button> -->
          </p>
        </div>
        <div class="separator"></div>
      </li>
      <li>
        <div class="article" v-if="allMonth">
        <a href="javascript:;" class="title_article">1 Month All Sports Package</a>
        <p class="text_article">
        Get our top rated plays. Every single expert pick for one month. Only <strike v-if="allMonth.current_price !== allMonth.previous_price">${{allMonth.previous_price}}</strike> ${{allMonth.current_price}}.
        <br />
        <purchase-button :package="allMonth" :color="'gold'"></purchase-button>
        <!-- <paypal-button :package="allMonth" :size="'medium'" :color="'gold'"></paypal-button> -->
        </p>
        </div>
        <div class="separator"></div>
    </li>
    <li>
      <div class="article" v-if="allTwo">
      <a href="javascript:;" class="title_article">2 Weeks All Sports Package</a>
      <p class="text_article">
      2 Weeks All Sports Package. Every single expert pick for 2 weeks. Only <strike v-if="allTwo.current_price !== allTwo.previous_price">${{allTwo.previous_price}}</strike> ${{allTwo.current_price}}.
      <br />
      <purchase-button :package="allTwo" :color="'gold'"></purchase-button>
      <!-- <paypal-button :package="allTwo" :size="'medium'" :color="'gold'"></paypal-button> -->
      </p>
      </div>
      <div class="separator"></div>
    </li>
    <li>
      <div class="article" v-if="allWeek">
      <a href="javascript:;" class="title_article">1 Week All Sports Package</a>
      <p class="text_article">
      1 Week All Sports Package. Every single expert pick for one week. Only <strike v-if="allWeek.current_price !== allWeek.previous_price">${{allWeek.previous_price}}</strike> ${{allWeek.current_price}}.
      <br />
      <purchase-button :package="allWeek" :color="'gold'"></purchase-button>
      <!-- <paypal-button :package="allWeek" :size="'medium'" :color="'gold'"></paypal-button> -->
      </p>
      </div>
    </li>
    </ul>
    <adsense
        ad-client="ca-pub-8213113866781504"
        ad-slot="7783278999"
        ad-layout-key="-8i+1w-dq+e9+ft"
        ad-format="fluid">
    </adsense>
  </div>
</div>
</template>

<script>
import Nav from '../components/Nav.vue'
import PickRepository from '../data/pick.repository.js'
import Adsense from '../components/adsense.vue'
import {PACKAGES} from '../constants'
// import PaypalButton from '../components/paypalButton'
import PurchaseButton from '../components/purchaseButton'
export default {
  components: {
    'navigation': Nav,
    'adsense': Adsense,
    // 'paypal-button': PaypalButton,
    'purchase-button': PurchaseButton
  },
  data () {
    return {
      picks: null
    }
  },
  created () {
    PickRepository.getPremium().then((p) => {
      this.picks = p
    })
  },
  computed: {
    user () {
      return this.$store.state.currentUser
    },
    allYear () {
      return this.$store.getters.package(PACKAGES.ALL_YEAR)
    },
    allMonth () {
      return this.$store.getters.package(PACKAGES.ALL_MONTH)
    },
    allTwo () {
      return this.$store.getters.package(PACKAGES.ALL_TWO)
    },
    allWeek () {
      return this.$store.getters.package(PACKAGES.ALL_ONE)
    }
  },
  metaInfo: {
    title: 'Picks'
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Picks.vue?673fc14e